import React from 'react';
import Container from 'evcharging/components/Container';
import Title from 'evcharging/components/Title';
import Spacer from 'evcharging/components/Spacer';
import Responsible from 'evcharging/components/Responsible';
import BenefitsItem, { BenefitsItemProps } from 'evcharging/containers/open-adr/BenefitsItem';
import { Theme } from 'evcharging/app/themes';
import { css } from '@emotion/css';
import drops from 'evcharging/assets/open-adr/benefitsBg.png';
import useTheme from 'evcharging/hooks/useTheme';
import useI18n from 'evcharging/hooks/useI18n';

const Benefits = () => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useI18n();
  const items: BenefitsItemProps[] = [
    {
      question: t('open.benefits1.question'),
      answer: t('open.benefits1.answer'),
    },
    {
      question: t('open.benefits2.question'),
      answer: t('open.benefits2.answer'),
    },
    {
      question: t('open.benefits3.question'),
      answer: t('open.benefits3.answer'),
    },
  ];

  return (
    <div className={styles.root}>
      <Container>
        <Title variant={'h2'}>
          {t('open.benefits.title1')}
          <br /> {t('open.benefits.title2')}
        </Title>
        <Spacer value={64} />
        <Responsible fractions={[31, 31, 31]}>
          {items.slice(0, 3).map((item, index) => (
            <BenefitsItem {...item} key={index} />
          ))}
        </Responsible>
      </Container>
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  root: css`
    background: #f6f8f9 url('${drops}') no-repeat;
    background-size: cover;
    height: 472px;

    > div {
      padding-top: 70px;
    }

    ${theme.breakpoints.mobile.down} {
      background: #f6f8f9;
      height: auto;
      > div {
        padding-top: 48px;
      }
    }
  `,
});

export default Benefits;
